import axios from '../utils/axios';

export default function getUnverifiedCompanies(recId,params) {
    return axios.get(`/admin/${recId}/companyManagement/v1/unverified-companies/all`,{ params })
}
